import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./FriendsGridLayout.css";
import "../../UserAccountGridLayout.css";
import UFGridCentreUpperLayout from "./Layout/UFGridCentreUpperLayout";
import UFGridLowerLayout from "./Layout/UFGridCentreLowerLayout";
import { ThemeContext } from "../../../../../context/ThemeContext";
import "../../Styles/ua-common-styles.css";
import PageProfileModal from "../../../../common/PopupPages/PageProfile";

const FriendsPageGrid = () => {
  const [selectedProfileId, setSelectedProfileId] = useState(null);
  const { theme } = useContext(ThemeContext);
  const [renderOperation, setRenderOperation] = useState(null);
  const [activetab, setActivetab] = useState("");
  const [displayMode, setDisplayMode] = useState("grid");
  const [friendsTab, setFriendsTab] = useState("current");
  const [selectedFriends, setSelectedFriends] = useState([]);
  const { userid } = useParams();

  useEffect(() => {
    import(`./Styles/themes/${theme}/themes.css`)
      .then(() => {
        console.log(`Loaded ${theme} styles for UserProfile`);
      })
      .catch(() => {
        console.error(`Theme CSS not found for ${theme}`);
      });
  }, [theme]);

  const handleCloseModal = () => {
    setRenderOperation(null);
  };

  const handleFriendSelect = (friends) => {
    setSelectedFriends(friends);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className="friends-page-grid" style={{ background: "var(--card-bg, rgb(4, 4, 4))", display: "flex", flexDirection: "column" }}>
        
        {/* ✅ Upper Container with Tabs, Search, and More Button */}
        <UFGridCentreUpperLayout
          renderOperation={renderOperation}
          setRenderOperation={setRenderOperation}
          friendsTab={friendsTab}
          setFriendsTab={setFriendsTab}
          selectedFriends={selectedFriends}
          onFriendSelect={handleFriendSelect}
        />

        {/* ✅ Lower Container - Conditionally rendered based on friendsTab */}
        <UFGridLowerLayout
          selectedProfileId={selectedProfileId}
          renderOperation={renderOperation}
          setRenderOperation={setRenderOperation}
          selectedFriends={selectedFriends}
          onFriendSelect={handleFriendSelect}
          friendsTab={friendsTab}
        />
      </div>

      {/* Modal for communication */}
      {["messaging", "audio", "video"].includes(renderOperation?.operationType) && (
        <PageProfileModal
          userId={renderOperation.data.userId}
          operationType={renderOperation.operationType}
          mode={renderOperation.mode}
          onClose={handleCloseModal}
        />
      )}

      {/* Copyright Footer */}
      <div style={{ justifyContent: "center", display: "flex", marginTop: 20 }}>
        <p className="cmn-copyright">
          Kleido AI, An Intelligent social Platform , Copyright © InitiumNet Technology Pvt Ltd.
        </p>
      </div>
    </div>
  );
};

export default FriendsPageGrid;
